import MORE_VIDEOS_ICON from '../assets/more-videos.svg';
import MORE_VIDEOS_BIG_ICON_AND_TEXT from '../assets/more-videos-big-button.svg';
import MORE_VIDEOS_SMALL_ICON_AND_TEXT from '../assets/more-videos-small-button.svg';
import RIGHT_ARROW_ICON from '../assets/right-arrow.svg';
import LEFT_ARROW_ICON from '../assets/left-arrow.svg';
import LEFT_ARROW_CIRCLE_ICON from '../assets/left-arrow-circle.svg';
import RIGHT_ARROW_CIRCLE_ICON from '../assets/right-arrow-circle.svg';

export const MORE_VIDEOS_ICON_TYPES = {
  MORE_VIDEOS_ICON,
  MORE_VIDEOS_SMALL_ICON_AND_TEXT,
  MORE_VIDEOS_BIG_ICON_AND_TEXT,
  RIGHT_ARROW_ICON,
  LEFT_ARROW_ICON,
  RIGHT_ARROW_CIRCLE_ICON,
  LEFT_ARROW_CIRCLE_ICON,
};
